import React from 'react'
import styles from '../styles/Reviews.module.scss'

interface NotContactMeOrMaybeLatterHappyProps {
  mood?: number
}

export const NotContactMeOrMaybeLatterHappy: React.FC<NotContactMeOrMaybeLatterHappyProps> = ({ mood }) => {

  return (
    <div className={styles.thank_you}>
      {
        mood && mood > 3 ? (
          <img src="/happy_thank_you.png" alt="Happy people"/>
        ) : null
      }

      <p className={styles.thank_you_text}>
        Thanks, we really appreciate your <br/>
        feedback
      </p>
    </div>
  )
}
